export const urlForConversation = (conversationId: number | string) =>
  `/conversations/${conversationId}`

export const urlForCampaign = (campaignId: number | string) => `/campaigns/${campaignId}`

export const prefixUrlWithHttp = (link?: string): string | undefined => {
  if (!link) return link

  const VALID_PREFIXES = ['http://', 'https://', 'mailto:']

  for (const prefix of VALID_PREFIXES) {
    if (link.startsWith(prefix)) {
      return link
    }
  }

  return `http://${link}`
}

export const getURLSearchParam = (key: string): string | null => {
  return new URLSearchParams(window.location.search.substr(1)).get(key)
}

export const getURLSearchParams = (): URLSearchParams => {
  return new URLSearchParams(window.location.search.substr(1))
}
